var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',{attrs:{"label":_vm.$t('Is component optional')},model:{value:(_vm.optional),callback:function ($$v) {_vm.optional=$$v},expression:"optional"}})}
var staticRenderFns = []

export { render, staticRenderFns }